module.exports = __webpack_public_path__ + "img/ecologi-cpw-white.ec5c307b.svg";